import { Record, Map } from 'immutable';
import { actions } from '../constants';
import { AddPatient } from '../components';
const { InviteStates } = AddPatient;

const initialState = new Record({
  emailState: InviteStates.UNSENT,
  smsState: InviteStates.UNSENT,
  emailError: null,
  smsError: null
})();

export default function patientReducer(state = initialState, action = null) {
  const { type, payload } = action;
  switch (type) {
    case actions.EMAIL_ACCESS_CODE_REQUESTED:
      return state.merge({
        emailError: null,
        emailState: InviteStates.SENDING
      });
    case actions.EMAIL_ACCESS_CODE_SENT:
      return state.merge({
        emailState: InviteStates.SENT
      });
    case actions.EMAIL_ACCESS_CODE_FAILED:
      return state.merge({
        emailState: InviteStates.UNSENT,
        emailError: payload.error
      });
    case actions.SMS_ACCESS_CODE_REQUESTED:
      return state.merge({
        smsError: null,
        smsState: InviteStates.SENDING
      });
    case actions.SMS_ACCESS_CODE_SENT:
      return state.merge({
        smsState: InviteStates.SENT
      });
    case actions.SMS_ACCESS_CODE_FAILED:
      return state.merge({
        smsState: InviteStates.UNSENT,
        smsError: payload.error
      });
    case actions.RESET_NEW_PATIENT:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/add-patient.js